module.exports = __webpack_public_path__ + "static/allerta_gialla-d34ac70a077cc00cae75c240d94fc534.png";